import { Select } from "antd";
import styled from "styled-components";

const SelectField = styled(Select)`
  width: 100%;
`;

export { SelectField };
